import React, { useRef, useState } from "react";
import { UploadCloud, ImagePlus, Check } from "lucide-react";

export default function UploadZone({ onFileSelected, file }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const handleFiles = (files) => {
    const f = files?.[0];
    if (!f) return;
    if (!f.type.startsWith("image/")) return;
    onFileSelected(f);
  };

  return (
    <div className="space-y-4">
      <div
        data-testid="upload-smile-zone"
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragging(false);
          handleFiles(e.dataTransfer.files);
        }}
        className={`relative cursor-pointer border border-dashed transition-colors p-10 md:p-14 text-center ${
          dragging
            ? "border-forest-600 bg-bone-200/40"
            : "border-bone-300 bg-bone-100 hover:bg-bone-200/40"
        }`}
      >
        <input
          ref={inputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp"
          className="hidden"
          data-testid="upload-input"
          onChange={(e) => handleFiles(e.target.files)}
        />
        {file ? (
          <div className="flex flex-col items-center gap-3">
            <div className="w-14 h-14 rounded-full bg-forest-600 text-white flex items-center justify-center">
              <Check size={22} strokeWidth={1.5} />
            </div>
            <div className="font-medium text-forest-600">{file.name}</div>
            <div className="text-xs text-forest-400">
              {(file.size / 1024 / 1024).toFixed(2)} MB · Click to change
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-4">
            <UploadCloud size={42} strokeWidth={1.2} className="text-forest-600" />
            <div>
              <div className="text-lg text-forest-700 font-medium">
                Drop your smiling selfie here
              </div>
              <div className="text-sm text-forest-400 mt-1">
                or click to browse · JPG, PNG, WebP up to 15&nbsp;MB
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="grid grid-cols-3 gap-4 text-xs">
        <Guideline n="01" t="Face camera" d="Look directly at the lens" />
        <Guideline n="02" t="Smile big" d="Show your teeth naturally" />
        <Guideline n="03" t="Good light" d="Bright, even daylight" />
      </div>
    </div>
  );
}

function Guideline({ n, t, d }) {
  return (
    <div className="border border-bone-200 bg-white p-4">
      <div className="overline">{n}</div>
      <div className="font-medium text-forest-700 text-sm mt-1">{t}</div>
      <div className="text-xs text-forest-400 mt-1 leading-relaxed">{d}</div>
    </div>
  );
}
